import httpClient from "../../clients/httpClient";
import { BenchmarkCompare, IReportSettingsValues, LivePortfolioRequest } from "../../interfaces/reports.interface";

export const getImplementationOverview = () =>
    httpClient.get(`/api/v1/admin/reports/implementation-overview`);

export const getOverdueWeek = (weekStart: string) =>
    httpClient.get(`/api/v1/admin/reports/implementation-overview/overdue-weeks/${weekStart}`);

export const getIntegrationsReport = () => httpClient.get(`/api/v1/admin/reports/integrations`);

export const getReportSettings = () => httpClient.get(`/api/v1/admin/reports/settings`);

export const updateReportSettings = (payload: Partial<IReportSettingsValues>) =>
    httpClient.patch(`/api/v1/admin/reports/settings`, payload);

export const getLivePortfolio = ({ start, end, refresh }: LivePortfolioRequest) =>
    httpClient.get(`/api/v1/admin/reports/live-portfolio`, { params: { start_date: start, end_date: end, ...(refresh ? { refresh: 1 } : {}) } });

export const getCustomerSuccess = () => httpClient.get(`/api/v1/admin/reports/customer-success`);

export const getCustomerSuccessBenchmarks = (organizationId: number, compare: BenchmarkCompare) =>
    httpClient.get(`/api/v1/admin/reports/customer-success/benchmarks`, { params: { organization_id: organizationId, compare } });
